import { Store } from "vuex";
import { namespace as searchFeedbackNamespace } from "../modules/searchFeedback/search-feedback";
import { SearchFeedbackPost } from "@infoland/iprova-api";

export class SearchFeebackStore {
    private store: Store<any>;
    constructor(store: Store<any>) {
        this.store = store;
    }
    /**
     * Adds a search feedback
     * @param name the setting name
     */
    public async createSearchFeedbackAsync(searchFeedbackModel: SearchFeedbackPost): Promise<number | null> {
        return this.store.dispatch(`${searchFeedbackNamespace}/createSearchFeedbackAsync`, searchFeedbackModel);
    }
}
